module.exports = __webpack_public_path__ + "img/asia-admin07.dfb597d1.png";